module.exports = __webpack_public_path__ + "img/family-logo.7c33ceca.png";